import React from "react"
import { Route } from "react-router-dom"

const Overview = React.lazy(() => import("./overview/Overview"))
const OKR = React.lazy(() => import("./okr/Okr"))
const Reviews = React.lazy(() => import("./reviews/Reviews"))
const StartReview = React.lazy(
  () => import("./reviews/start-reviews/ReviewSteps")
)
const ArcDepartments = React.lazy(() => import("./reviews/arc/ArcDepartments"))
const ArcViewReviewee = React.lazy(
  () => import("./reviews/arc/ArcViewReviewee")
)
const ViewReviewPeriodEmployee = React.lazy(
  () => import("./reviews/view-review/ViewReviewPeriodEmployee")
)

const employeePerformanceRoutes = (
  <>
    <Route path="performance/">
      <Route
        path="overview"
        element={<Overview />}
      />
      <Route
        path="okr"
        element={<OKR />}
      />
      <Route
        path="reviews"
        element={<Reviews />}
      />
      <Route
        path="reviews/start/:assignmentKey"
        element={<StartReview />}
      />
      <Route
        path="reviews/view/:cdKey/:reviewPeriodKey/:assignmentKey/:revieweeKey"
        element={<ViewReviewPeriodEmployee viewType="completed-assignment" />}
      />
      <Route
        path="reviews/view/:cdKey/:reviewPeriodKey"
        element={<ViewReviewPeriodEmployee viewType="completed-review" />}
      />

      <Route
        path="reviews/arc/start/:reviewPeriodKey/departments"
        element={<ArcDepartments />}
      />
      <Route
        path="reviews/arc/start/:reviewPeriodKey/:revieweeId/:cdKey"
        element={<ArcViewReviewee />}
      />
    </Route>
  </>
)

export default employeePerformanceRoutes
